import { render } from "./productConfigurationSummaryItem.vue?vue&type=template&id=4ce7006d&scoped=true&ts=true"
import script from "./productConfigurationSummaryItem.vue?vue&type=script&lang=ts"
export * from "./productConfigurationSummaryItem.vue?vue&type=script&lang=ts"

import "./productConfigurationSummaryItem.vue?vue&type=style&index=0&id=4ce7006d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce7006d"]])

export default __exports__